import React from 'react';
/** @jsx jsx */
import { jsx, Grid, Container, Box } from 'theme-ui';

// Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import { PostDetails as PostDetailsType } from '../../@codersclan/gatsby-theme-airfleet/@types/post';

// Helpers
import { getCategory, getCtaLabel } from '../../helpers/postHelper';

// Components
import Text, { TEXT_TYPES } from '../../components/text';
import Card from '../../components/card';

import * as Styles from './style';

interface TitleRelatedContentProps extends Section {
  title?: {
    title?: string;
  };
  relatedContent?: {
    related?: {
      postSelector?: PostDetailsType;
    }[];
  };
}

const TitleRelatedContent: SectionComponent<TitleRelatedContentProps> = React.memo(
  ({ title, relatedContent }) => (
    <Container sx={Styles.Container}>
      {!!title?.title && (
        <Text type={TEXT_TYPES.H2} sx={Styles.Title}>
          <span dangerouslySetInnerHTML={{ __html: title?.title }} />
        </Text>
      )}
      <Grid columns={[1, 3]} sx={Styles.Grid} key="latest_content_grid">
        {relatedContent?.related?.map(({ postSelector: p }) =>
          p ? (
            <Box key={p.id}>
              <Card
                image={p.featuredImage?.node}
                category={getCategory(p).name}
                title={p.title}
                content={p.excerpt}
                cta={{
                  label: getCtaLabel(p!),
                  url: p.uri,
                  target: '_self',
                }}
              />
            </Box>
          ) : null,
        )}
      </Grid>
    </Container>
  ),
);

export default TitleRelatedContent;
